import { IStore } from 'src/interfaces/store';

/**
 * @description Extract the names of the stores from the array of stores
 * @param stores - The array of stores
 * @returns The array of store names
 */

export const extractStoresNames = (stores: IStore[]): string[] => {
    let result: string[] = [];
    if (!stores || stores.length === 0) return result;
    stores.map((item) => result.push(item.name));
    return result;
};
